import { z } from 'zod';

const schema = z.object({
  VITE_API_BASE_URL: z.string().url().default('http://localhost:3000'),
  VITE_MAP_STYLE_URL: z.string().default('/maps/default.json'),
  VITE_SENTRY_DSN: z.string().optional(),
  // Accept same-origin Pages Functions paths (for example `/api/contact`) as
  // well as absolute endpoints used by a separately hosted API.
  VITE_CONTACT_FORM_ENDPOINT: z.union([z.string().url(), z.string().regex(/^\//)]).optional(),
  VITE_CONTACT_EMAIL: z.string().email().default('hola@gtfs-manager.com'),
});

const parsed = schema.safeParse({
  VITE_API_BASE_URL: import.meta.env.VITE_API_BASE_URL,
  VITE_MAP_STYLE_URL: import.meta.env.VITE_MAP_STYLE_URL,
  VITE_SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
  VITE_CONTACT_FORM_ENDPOINT:
    import.meta.env.VITE_CONTACT_FORM_ENDPOINT || (import.meta.env.MODE === 'public' ? '/api/contact' : undefined),
  VITE_CONTACT_EMAIL: import.meta.env.VITE_CONTACT_EMAIL,
});

if (!parsed.success) {
  console.error('Invalid environment variables', parsed.error.flatten().fieldErrors);
}

export const env = parsed.success
  ? parsed.data
  : schema.parse({});
